module.exports = __webpack_public_path__ + "img/main3.0843a837.png";